﻿<rdo-overlay [enabled]="loading()"></rdo-overlay>
<rdo-breadcrumb></rdo-breadcrumb>
<div class="container-fluid" id="rdo-grid">
  <div class="row">
    <div class="col-12 grid-container">
      <ng-container *featureFlag="'flagSavedViews'">
        <rdo-saved-views
          [gridName]="gridName"
          [pageName]="translateService.instant('main.navigation.search_bar.customers')"
          />
      </ng-container>
      @if (customers) {
        <rdo-grid-table-ng
          #grid
          [name]="gridName"
          [gridConfig]="gridConfig()"
          [pagedData]="customers"
          [sorting]="sorting"
          [scrollScale]="'largeScale'"
          [(paging)]="paging"
          (pageOnChange)="changePage($event)"
          (lazyLoadOnChange)="changeLazyLoad($event)"
          [totalCount]="totalCount"
          [frozenWidth]="frozenWidth"
          [showColumnSelector]="true"
          (visibilityChanged)="visibilityChanged($event)"
          (downloadExcelClick)="exportExcel($event)"
          [alwaysShowPager]="false"
          />
      }
    </div>
  </div>
</div>
